import React from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { Modal } from 'react-bootstrap';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type ModalSkeletonProps = {
  show: boolean;
  heading: string;
  onClose: () => void;
  onDeny: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
  viewOnly: boolean;
};

export function ModalSkeleton({
  show,
  heading,
  onClose,
  onDeny,
  onConfirm,
  children,
  viewOnly,
}: ModalSkeletonProps) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton closeVariant="white" className="gap-3">
        <SharedIcon iconName="people" size="md" color="primary" />
        <Modal.Title>{heading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {!viewOnly && (
        <Modal.Footer>
          <div className="button-group">
            <StylishNewButton
              type="button"
              className="button--error button--reverse"
              onClick={onDeny}
            >
              Deny
            </StylishNewButton>
            <StylishNewButton
              type="button"
              className="button--primary"
              onClick={onConfirm}
            >
              Approve
            </StylishNewButton>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
}
